import React from 'react';

const NewCommodityRequestsScreen = () => {
	return <div>NewCommodityRequestsScreen</div>;
};

export default NewCommodityRequestsScreen;
